import styled from "styled-components";

const TextInput = ({ value, onChange, placeholderText }) => {
  return (
    <Wrapper>
      <textarea
        placeholder={placeholderText}
        value={value}
        onChange={onChange}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;

  textarea {
    width: 100%;
    min-height: 180px;
    padding: 16px 18px;

    border-radius: 14px;
    border: 1px dashed rgba(168, 168, 168, 1);

    background: rgba(255, 255, 255, 1);
    color: black;
    font-family: "Montserrat", sans-serif;
    font-size: 16px;
  
    transition: all 0.2s ease;
    resize: none;
    
    backdrop-filter: blur(6px);
  }

  textarea::placeholder {
    color: rgba(255, 255, 255, 1);
  }

  textarea:focus {
    outline:none;
  }

  textarea:hover {
    border-color: rgba(0, 0, 0, 1);
  }

  @media (max-width: 600px) {
    textarea {
      min-height: 145px;
      font-size: 13px;
    }
  }
`;

export default TextInput;
